module.exports = __webpack_public_path__ + "static/media/VF-logo-horizontal.26a65a92.svg";